import { supabase } from '../lib/supabase';

export const authService = {
  async signIn(email, password) {
    try {
      const { data, error } = await supabase?.auth?.signInWithPassword({
        email,
        password
      });

      if (error) throw error;

      // Verify user has owner, contributor, or user role - fetch full profile
      const { data: profile, error: profileError } = await supabase?.from('user_profiles')?.select('*')?.eq('id', data?.user?.id)?.single();

      if (profileError) {
        // If profile doesn't exist, sign out and throw error
        await supabase?.auth?.signOut();
        throw new Error('User profile not found. Please contact administrator.');
      }

      if (!profile?.is_active) {
        await supabase?.auth?.signOut();
        throw new Error('Account is inactive. Please contact administrator.');
      }

      return { data, profile, error: null };
    } catch (error) {
      return { data: null, profile: null, error };
    }
  },

  async signUp(email, password, userData, userType = 'user') {
    try {
      const { data, error } = await supabase?.auth?.signUp({
        email,
        password,
        options: {
          data: {
            ...userData,
            role: userType
          },
          emailRedirectTo: `${window.location?.origin}/${userType === 'contributor' ? 'admin-login' : 'user-registration'}?verified=true`
        }
      });

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  async signOut() {
    try {
      const { error } = await supabase?.auth?.signOut();
      return { error };
    } catch (error) {
      return { error };
    }
  },

  async getCurrentUser() {
    try {
      const { data: { user }, error } = await supabase?.auth?.getUser();
      if (error) throw error;

      if (user) {
        const { data: profile, error: profileError } = await supabase?.from('user_profiles')?.select('*')?.eq('id', user?.id)?.single();

        if (profileError) throw profileError;
        return { user, profile, error: null };
      }

      return { user: null, profile: null, error: null };
    } catch (error) {
      return { user: null, profile: null, error };
    }
  },

  async resendVerificationEmail(email) {
    try {
      const { error } = await supabase?.auth?.resend({
        type: 'signup',
        email
      });

      if (error) throw error;

      return { success: true, error: null };
    } catch (error) {
      return { success: false, error };
    }
  }
};
